import React, { useEffect, useRef, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";
import FeatherIcon from "feather-icons-react";
import useApi from "../../../core/customhook/useApi";
import axios from "axios";
import { apibaseurl, employee_id, jwttoken } from "../../../environment";
import moment from "moment";
import Loader from "../../../core/common/selfLoder";
import "./wetalk.css";
import Confetti from "react-confetti";
// import { useWindowSize } from "react-use";

const Wetalk = () => {
  const emojiPickerRef = useRef(null);
  const emojiButtonRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [activeCommentBoxId, setActiveCommentBoxId] = useState(null);
  const [postComments, setPostComments] = useState({});
  const [activeTab, setActiveTab] = useState("WT2025001");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [wishingData, steWishingData] = useState([]);
  const [teambirthday, setTeambirthday] = useState([]);
  const [commentInputs, setCommentInputs] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [posts, setPosts] = useState([]);
  const [showCelebration, setShowCelebration] = useState(true);

  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji;

    setCommentInputs((prevInputs) => ({
      ...prevInputs,
      [activeCommentBoxId]: (prevInputs[activeCommentBoxId] || "") + emoji,
    }));
  };

  const {
    data: weTalk,
    loading: weTalkLoading,
    error: weTalkError,
  } = useApi("/api/master/get-posts-type", { method: "GET", autoCall: true });

  const { callApi: fetchPosts, loading: fetchPostsLoading } = useApi(
    "/api/posts",
    { method: "POST", autoCall: false }
  );
  const getPosttime = (postTimeData) => {
    const timeAgo = moment(postTimeData).fromNow();
    return timeAgo;
  };

  const { callApi: fetchComments, loading: fetchCommentsLoading } = useApi(
    "/api/get-comments",
    { method: "POST", autoCall: false }
  );

  const { callApi: addComment, loading: addCommentLoading } = useApi(
    "/api/add-comments",
    { method: "POST", autoCall: false }
  );

  const deleteComment = async (commentID, postID) => {
    try {
      const response = await axios.delete(
        `${apibaseurl}/api/delete-comment/${commentID}`,
        {
          headers: {
            Authorization: `Bearer ${jwttoken}`,
          },
        }
      );
      if (response.status === 200) {
        getPostComments(postID);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { callApi: fetchBirthdays, loading: fetchBirthdaysLoading } = useApi(
    "/api/upcoming-teams-birthday",
    { method: "GET", autoCall: false }
  );

  const formatDate = (dob) => {
    const [day, month] = dob.split("/");
    const currentYear = new Date().getFullYear();
    const birthdayDate = new Date(`${currentYear}-${month}-${day}`);
    const dayNumber = birthdayDate.getDate();
    const monthName = birthdayDate.toLocaleString("default", { month: "long" });
    return `${dayNumber} ${monthName} ${currentYear} 🎂🎂🎂`;
  };

  const ITEMS_PER_PAGE = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const formattedList = teambirthday.map((person) => ({
    name: person.employee_name,
    date: formatDate(person.date_of_birth),
  }));
  const totalPages = Math.ceil(formattedList.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentList = formattedList.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  const { callApi: likePostApi, loading: likePostLoading } = useApi(
    "/api/like-post",
    { method: "POST", autoCall: false }
  );

  const getDataWeTalk = async () => {
    setLoading(true);
    try {
      const response = await fetchPosts({ category: activeTab || "WT2025001" });
      if (response) {
        steWishingData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getPostComments = async (PostID) => {
    try {
      const response = await fetchComments({ post_id: PostID });
      if (response) {
        setPostComments((prev) => ({
          ...prev,
          [PostID]: response.data,
        }));
      }
      await getDataWeTalk();
    } catch (error) {
      console.error(error);
    }
  };

  const postCommentData = async (ID) => {
    try {
      const commentText = commentInputs[ID];
      if (!commentText || commentText.trim() === "") return;

      const response = await addComment({ post_id: ID, comment: commentText });
      if (response) {
        setCommentInputs((prev) => ({ ...prev, [ID]: "" }));
        getPostComments(ID);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getBirthdayData = async () => {
    try {
      const response = await fetchBirthdays();
      if (response) {
        setTeambirthday(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLikePost = async (postId) => {
    if (likedPosts[postId]) return;
    try {
      const response = await likePostApi({ post_id: postId });
      if (response) {
        setLikedPosts((prev) => ({ ...prev, [postId]: true }));
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.ID === postId ? { ...post, likes: post.likes + 1 } : post
          )
        );
        await getDataWeTalk();
      }
    } catch (error) {
      console.error("Error liking post:", error);
    }
  };

  useEffect(() => {
    getDataWeTalk();
  }, [activeTab]);

  useEffect(() => {
    getBirthdayData();
  }, []);

  useEffect(() => {
    if (activeCommentBoxId) {
      getPostComments(activeCommentBoxId);
    }
  }, [activeCommentBoxId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target) &&
        emojiButtonRef.current &&
        !emojiButtonRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    const celebrationTimer = setTimeout(() => {
      setShowCelebration(false);
    }, 10000); // after 1 minute
    return () => clearTimeout(celebrationTimer);
  }, []);



  return (
    <>
      <Loader loading={weTalkLoading || loading} />;
      <div className="page-wrapper py-4">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Team Chat</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication & Culture</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Team Chat
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <img
              src="https://team1consulting.com/weconnect/assets/img/we-talk-banner.png"
              alt=""
            />
          </div>

          <div className="col-md-9">
            <div className="card">
              <div className="card-body p-3">
                <div className="d-flex align-items-center justify-content-center">
                  <div
                    className="w-100"
                    style={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <ul
                      className="nav nav-tabs justify-content-center flex-nowrap"
                      style={{ minWidth: "max-content", overflowY: "hidden" }}
                    >
                      {weTalk?.data.map((tab) => (
                        <li
                          className="nav-item d-inline-block"
                          key={tab.type_id}
                        >
                          <button
                            className="nav-link px-4 py-2 rounded mb-1"
                            onClick={() => setActiveTab(tab.type_id)}
                            style={{
                              backgroundColor:
                                activeTab === tab.type_id
                                  ? "#2E3294"
                                  : "transparent",
                              color:
                                activeTab === tab.type_id ? "white" : "black",
                              border: "1px solid",
                              borderColor:
                                activeTab === tab.type_id ? "#2E3294" : "#ddd",
                            }}
                          >
                            {tab.type_name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xxl-9 col-xl-8">
              {wishingData.map((item, index) => (
                <div key={index} className="wetalk-card">
                  <div className="wetalk-card-body">
                    {activeTab === "WT2025003" ? (
                      <>
                        <div>
                          <div className="wetalk-user-info">
                            <img
                              src="./assets/img/wetalk/recognisation.svg"
                              alt="user"
                              className="wetalk-user-img"
                            />
                            <div>
                              <h6 className="wetalk-employee-name">
                                <span className="text-primary">
                                  {item?.recognised_person}
                                </span>{" "}
                                has been recognized by{" "}
                                <span className="text-primary">
                                  {item?.recognised_by_name}
                                </span>{" "}
                                under the{" "}
                                <span className="text-primary">
                                  {item.award_name}
                                </span>{" "}
                                program.
                              </h6>
                              <small className="wetalk-post-date">
                                {getPosttime(item.post_date)}
                                <span className="wetalk-check-icon">
                                  <FeatherIcon icon="check-square" size={16} />
                                </span>
                              </small>
                            </div>
                          </div>
                          <div className="wetalk-award-section">
                            <div className="wetalk-award-icon">
                              <div>
                                <img src={item.icon} alt="Award Icon" />
                              </div>
                              <p>{item.award_name}</p>
                            </div>
                            <div className="wetalk-award-description">
                              <h4>Citation</h4>
                              <p>{item.reward_description}</p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : activeTab === "WT2025002" ? (
                      <div>
                        <div className="wetalk-user-info">
                          <img
                            src="./assets/img/wetalk/recognisation.svg"
                            alt="user"
                            className="wetalk-user-img"
                          />
                          <div>
                            <h6 className="wetalk-employee-name">
                              Team1 Consulting wishes{" "}
                              <span className="text-primary">
                                {item.wished_person_name}
                              </span>{" "}
                              a very Happy Work Anniversary.
                            </h6>
                            <small className="wetalk-post-date">
                              {getPosttime(item.post_date)}
                              <span className="wetalk-check-icon">
                                <FeatherIcon icon="check-square" size={16} />
                              </span>
                            </small>
                          </div>
                        </div>
                        <div
                          className="wetalk-bg-image"
                          style={{
                            backgroundImage: `url("./assets/img/wetalk/Celebration.gif")`,
                          }}
                        >
                          <div className="wetalk-bg-overlay" />
                          <div className="wetalk-bg-text">
                            <div>
                              <h4>Hey {item.wished_person_name},</h4>
                              <h4>Wish you a happy</h4>
                              <h1>Work Anniversary</h1>
                            </div>
                            <h6>{moment(item.post_date).format("MMMM, D")}</h6>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="wetalk-user-info">
                          <img
                            src="./assets/img/wetalk/recognisation.svg"
                            alt="user"
                            className="wetalk-user-img"
                          />
                          <div>
                            <h6 className="wetalk-employee-name">
                              Team1 Consulting wishes{" "}
                              <span className="text-primary">
                                {item.wished_person_name}
                              </span>{" "}
                              a very Happy Birthday.
                            </h6>
                            <small className="wetalk-post-date">
                              {getPosttime(item.post_date)}
                              <span className="wetalk-check-icon">
                                <FeatherIcon icon="check-square" size={16} />
                              </span>
                            </small>
                          </div>
                        </div>
                        <div
                          className="wetalk-bg-image"
                          style={{
                            backgroundImage: `url("./assets/img/wetalk/bday-bg-4.gif")`,
                          }}
                        >
                          <div className="wetalk-bg-overlay" />
                          <div className="wetalk-bg-text">
                            <div>
                              <h4>Hey {item.wished_person_name},</h4>
                              <h4>Wish you</h4>
                              <h1>Happy Birthday</h1>
                            </div>
                            <h6>{moment(item.post_date).format("MMMM, D")}</h6>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="wetalk-actions">
                      <button
                        className={`wetalk-btn like-btn ${
                          likedPosts[item.ID] ? "liked" : ""
                        }`}
                        onClick={() => handleLikePost(item.ID)}
                        disabled={likedPosts[item.ID]}
                      >
                        <FeatherIcon
                          icon="heart"
                          size={16}
                          className={`wetalk-icon ${
                            likedPosts[item.ID] ? "text-danger" : ""
                          }`}
                        />
                        {item.likes} {item.is_liked ===1 ? "Liked" : "Like"}
                      </button>

                      <button
                        className="wetalk-btn comment-btn"
                        onClick={() => {
                          if (activeCommentBoxId !== item.ID) {
                            setCommentInputs({});
                          }
                          setActiveCommentBoxId(
                            activeCommentBoxId === item.ID ? null : item.ID
                          );
                        }}
                      >
                        <FeatherIcon
                          icon="message-circle"
                          size={16}
                          className="wetalk-icon"
                        />
                        {item.comments || "0"} Comment
                        {(postComments[item.ID]?.length || "") !== 1 ? "s" : ""}
                      </button>
                    </div>

                    {activeCommentBoxId === item.ID && (
                      <div className="wetalk-comment-box">
                        <div className="wetalk-input-group">
                          <input
                            type="text"
                            className="wetalk-input"
                            placeholder="Write a comment..."
                            value={commentInputs[item.ID] || ""}
                            onChange={(e) =>
                              setCommentInputs({
                                ...commentInputs,
                                [item.ID]: e.target.value,
                              })
                            }
                          />

                          <div className="wetalk-input-buttons">
                            <button
                              ref={emojiButtonRef}
                              className="wetalk-btn emoji-btn"
                              onClick={() =>
                                setShowEmojiPicker(!showEmojiPicker)
                              }
                              type="button"
                            >
                              😀
                            </button>
                            <button
                              className="wetalk-btn post-btn"
                              onClick={() => postCommentData(item.ID)}
                              type="button"
                            >
                              <FeatherIcon icon="navigation" size={16} />
                            </button>
                          </div>
                        </div>

                        {showEmojiPicker && (
                          <div
                            className="wetalk-emoji-picker"
                            ref={emojiPickerRef}
                          >
                            <EmojiPicker onEmojiClick={handleEmojiClick} />
                          </div>
                        )}
                      </div>
                    )}

                    {activeCommentBoxId === item.ID &&
                      postComments[item.ID]?.map((comment, index) => (
                        <div key={index} className="wetalk-comment">
                          <div className="wetalk-comment-header">
                            <small className="wetalk-comment-author">
                              {comment?.commented_by === employee_id
                                ? "You"
                                : comment?.employee_name}
                            </small>
                            <small className="wetalk-comment-time">
                              {moment(comment.created_date).fromNow()}
                            </small>
                          </div>
                          <p className="wetalk-comment-text">
                            {comment.comment}
                          </p>
                          {comment?.commented_by === employee_id ? (
                            <div className="wetalk-comment-actions">
                              {/* <button
                              className="wetalk-btn-link reply-btn"
                              onClick={() =>
                                replyToComment(
                                  item.ID,
                                  comment.id,
                                  "Your reply here"
                                )
                              }
                            >
                              Reply
                            </button> */}
                              <button
                                className="wetalk-btn-link delete-btn"
                                onClick={() =>
                                  deleteComment(comment.id, item.ID)
                                }
                              >
                                Delete
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "60px", zIndex: 100 }}
              >
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <h5 className="mb-0 fw-bold text-dark">
                        🎂 Upcoming Birthdays
                      </h5>
                      <span className="badge bg-success rounded-pill">
                        {formattedList.length}
                      </span>
                    </div>

                    {currentList.map((person, index) => (
                      <div
                        key={index}
                        className={`border-start ps-3 mb-3 ${
                          index % 3 === 0
                            ? "border-primary"
                            : index % 3 === 1
                            ? "border-warning"
                            : "border-success"
                        } border-4`}
                      >
                        <h6 className="fw-semibold mb-1 text-dark">
                          {person.name}
                        </h6>
                        <p className="mb-0 text-muted small">
                          <i className="bi bi-calendar-event-fill text-info me-2"></i>
                          {person.date}
                        </p>
                      </div>
                    ))}

                    <div className="d-flex justify-content-between mt-3">
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showCelebration && (
          <>
            <Confetti width={window.innerWidth} height={window.innerHeight} />
            {/* <div className="celebration-message">🎉 Celebrations Begin! 🎉</div> */}
          </>
        )}

        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Wetalk;

